<template>
	<div id="tz-table" v-loading="loading" element-loading-text="玩命加载中……" element-loading-spinner="el-icon-loading">
		<el-table ref="elTable" :data="data" v-bind='tableProps' width='100%' :style="tableStyle" @sort-change='sortChange'>
			<!-- 多选 -->
			<el-table-column v-if="multSelect" type="selection" width="55" v-bind='multSelectProps' />
			<!-- 索引 -->
			<el-table-column v-if="index" type="index" width="50" align='center' v-bind='indexProps'>
				<template #header>
					<span :class="indexProps.icon">{{indexProps.lable}}</span>
				</template>
				<template #default="scope">
					<span class="index-color">{{scope.$index+1}}</span>
				</template>
			</el-table-column>
			<!-- 遍历项 -->
			<el-table-column v-for="(v,i) in columns" :key="i" :label="v.label" :prop="v.prop" align='center'
				v-bind='v.colProps'>

				<!-- 插槽 -->
				<template #default="scope" v-if="v.slot">
					<slot :name="v.name" :row="scope.row"></slot>
				</template>

				<!-- 默认列 -->
				<template #default="scope" v-else-if="v.type=='text'||v.type=='undefined'">
					<span>{{Eval(v.prop,scope.row)}}</span>
				</template>

				<!-- 文本数组 -->
				<template #default="scope" v-else-if="v.type=='textArray'">
					<div id="" v-if="v.children.length">
						<!-- children  [{label:'',val:0}] -->
						<div v-for="(children,childrenKey) in v.children" :key="childrenKey">
							<span class="children-lable" :style="children.style">{{children.label}}</span>
							<span>{{Eval(children.prop,scope.row)||children.empty}}</span>
							<span class="unit" v-if="children.unit" >{{children.unit}}</span>
						</div>
					</div>
					<div v-else>{{v.empty}}</div>
				</template>
				
				
				<!-- 状态列 -->
				<template #default="scope" v-else-if="v.type == 'status'">
					<span
						v-status:[v.typeData]="{value:evalPro(v.prop,scope),key:v.key,propData:v.propData}">{{scope.row[v.prop]}}</span>
				</template>

				<!-- 图片列 -->
				<template #default="scope" v-else-if="v.type == 'images'">
					<!-- prop 数组 -->
					<div v-if="isArray(scope.row[v.prop])">
						<div class="imageArea">
							<el-image :key="index" v-for="(item,index) in scope.row[v.prop]" class="elImage" :src="item"
								fit="cover" :preview-src-list="scope.row[v.prop]"></el-image>
						</div>
					</div>
					<!-- children 字符串数组 ['img1','img2'] -->
					<div v-else-if="item.children.length">
						<div class="imageArea">
							<el-image :key="index" v-for="(item,index) in item.children" class="elImage"
								:src="scope.row[item]" fit="cover" :preview-src-list="scope.row[item]"></el-image>
						</div>
					</div>
				</template>
			</el-table-column>


			<!-- 按钮操作栏 -->
			<el-table-column fixed="right" label="操作" v-if="actionGroup.length!=0" align="center" width="320"
				v-bind='actionProps'>
				<template #default="scope">
					<!-- 插槽 action-->
					<slot name="action" :data="scope.row">
						<div class="actionWrap">
							<div class="actionDiv" :key="index" v-for="(item,index) in actionGroup"
								v-permission="item.permission">
								<div class="actionItem" v-if="Eval(item.showRules,scope.row)">
									<el-popconfirm :title="'确定删除'+(item.text||'')+'吗？'" confirmButtonText="确定"
										cancelButtonText="取消" @confirm="actionBtnTap(scope.row,index,item)"
										v-if="item.eventType=='delete'">
										<template #reference>
											<el-button :type="item.type||'danger'">{{item.text||'删除'}}
											</el-button>
										</template>
									</el-popconfirm>

									<el-button v-if="!item.eventType" :type="item.type"
										@click="actionBtnTap(scope.row,index,item)">{{item.text}}</el-button>
								</div>
							</div>
						</div>
					</slot>
				</template>
			</el-table-column>
		</el-table>
		<div class="pageArea" v-if="isShowPagination">
			<slot name="pagination">
				<el-pagination :background="false" @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="pageData.current_page" :page-size="page.page_size" :page-sizes="pageSizes"
					layout="total, sizes, prev, pager, next, jumper" :total="page.total" v-bind='paginationPros'>
				</el-pagination>
			</slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: "tz-table",
		props: {
			loading: Boolean,
			//表格数据
			data: Array,
			//表格其他参数 同el-table 一样
			tableProps: {
				type: Object,
				default: () => {
					return {}
				}
			},
			//表格样式
			tableStyle: {
				type: Object,
				default: () => {
					return {
						width: '100%',
					}
				}
			},
			columns:Array,
			//列参数
			colProps: {
				type: Object,
				default: () => {
					return {

					}
				}
			},
			//多选
			multSelect: Boolean,
			//多选props
			multSelectProps: {
				type: Object,
				default: () => {
					return {
					
					}
				}
			},
			//索引
			index: Boolean,
			//单选props
			indexProps: {
				type: Object,
				default: () => {
					return {
						icon: 'el-icon-setting',
						lable: '',
					}
				}
			},
			actionGroup:{
				type: Array,
				default: () => []
			},
			/* 分页 */
			//分页是否显示
			isShowPagination: {
				type: Boolean,
				default: true
			},
			// 分页每页展示数
			pageSizes: {
				type: Array,
				default: ()=>[10, 20, 50, 100]
			},
			// 分页对象
			page: {
				type: Object,
				default: ()=>{
					return {
						current_page: 1,
						page_size: 10,
					}
				}
			},
			// 数据总数
			total: {
				type: Number,
				default: 0
			},
			//分页 额外 参数
			paginationPros: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				pageData:{
					current_page: 1,
					page_size: 10,
				}
			}
		},
		mounted() {
			this.pageData={...this.page}
		},
		methods: {
			//排序
			sortChange({column, prop, order} ){
				let sortBy=''
				// DESC倒序ASC正序
				//console.log(column, prop, order)
				if(order==='ascending'){
					sortBy='ASC'
				}
				if(order==='descending'){
					sortBy='DESC'
				}
				this.$emit('sortChange', {column, prop, order:sortBy })
			},
			// 操作按钮被点击
			actionBtnTap(data, index, item) {
				let obj = {
					data,
					index,
					item, //action.item
				}
				this.$emit('actionBtnTap', obj)
			},
			// 解析字符串当成JS表达式处理
			Eval(prop,scope) {
				let expres = true
				if (prop&&scope) {
					expres =eval(`scope.${prop}`)+''
				}
				return expres
			},
			/* 分页 */
			handleSizeChange(val){
				this.pageData.page_size=val
				this.$emit('pageChange', {current_page:this.pageData.current_page,page_size:this.pageData.page_size})
			},
			handleCurrentChange(val){
				this.pageData.current_page=val||1
				
				this.$emit('pageChange', {current_page:this.pageData.current_page,page_size:this.pageData.page_size})
				console.log(this.pageData)
			}
		},
		watch: {}
	}
</script>

<style lang="scss" scoped>
	/* text */
	.children-lable{
		text-align: right;
		width: 50px;
	}
	
	/* 图片列 */
	.imageArea {
		display: flex;
		flex-direction: row;
		justify-content: center;

		.elImage {
			display: flex;
			width: 100px;
			height: 100px;
			margin: 0 10px;
		}
	}

	/* 分页 */
	.pageArea {
		height: 60px;
		width: 100%;
		margin-bottom: 30px;
		background: #F6F7F9;
		border: 1px solid #E0E7ED;
		border-top: none;
		border-radius: 0px 0px 5px 5px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
	}
</style>
